<template>
	<div>
		<div
			v-if="enabled"
			:id="uniqueId"
			class="cf-turnstile"
			:data-sitekey="siteKey"
		/>
	</div>
</template>

<script>
/* eslint-disable no-prototype-builtins */
export default {
    name: "Recaptcha",
    props: {},
    data() {
        return {
            widgetId: undefined,
            //Utilizado ela para não entrar em loop infinito
            hasError: false,

            //Utilizo ela para destruir o elemento
            enabled: true,
            token: null,
            // Track if Turnstile was successfully rendered
            turnstileRendered: false,
        }
    },
    computed: {
        siteKey() {
            let el = document.querySelector('input[name=siteKey]')
            if (el) {
                return JSON.parse(el.value)
            }

            return process.env.MIX_INVISIBLE_RECAPTCHA_SITEKEY
        },
        uniqueId() {
            return `recaptcha-js-${this._uid}`
        }
    },
    mounted() {
        // render the recaptcha widget when the component is mounted
        setTimeout(() => {
            if (window.hasOwnProperty('turnstile')) {
                this.render()
                window.addEventListener('beforeunload', this.leaving)
            }
        }, 1500)
    },
    methods: {
        execute() {
            if (window.hasOwnProperty('grecaptcha')) {
                window.grecaptcha.execute(this.widgetId)
            }

            if (window.hasOwnProperty('turnstile')) {
                window.turnstile.execute(this.uniqueId)
            }
        },
        reset() {
            try {
                if (window.hasOwnProperty('grecaptcha') && this.widgetId !== undefined) {
                    window.grecaptcha.reset(this.widgetId)
                }

                // Only reset Turnstile if it was successfully rendered
                if (window.hasOwnProperty('turnstile') && this.turnstileRendered) {
                    window.turnstile.reset(this.uniqueId)
                }
            } catch (e) {
                console.debug('Recaptcha/Turnstile reset error (ignored):', e)
            }
        },
        render() {
            this.enabled = true;

            let token = document.querySelector('input[name=captcha_token]')?.value;

            if (token) {
                this.$emit('rendered', token)
                return;
            }

            console.debug('render captcha')

            if (window.hasOwnProperty('turnstile')) {
                this.renderTurnstile();
            }

            if (window.hasOwnProperty('grecaptcha')) {
                this.renderGoogleRecaptcha();
            }
        },
        leaving() {
            console.debug('destroy recaptcha');
            this.reset()
        },
        renderTurnstile() {
            console.debug('render turnstile')

            // Check if siteKey is valid before rendering
            if (!this.siteKey || typeof this.siteKey !== 'string') {
                console.debug('Turnstile siteKey not configured, skipping render')
                return;
            }

            try {
                turnstile.render(`#${this.uniqueId}`, {
                    sitekey: this.siteKey,
                    callback: (token) => {
                        console.log(`Challenge Success ${token}`);
                        this.token = token;
                        this.turnstileRendered = true;
                        let input = document.createElement('input');
                        input.setAttribute('type', 'hidden');
                        input.setAttribute('name', 'captcha_token');
                        input.setAttribute('value', token);
                        document.querySelector('body').appendChild(input);

                        this.$emit('rendered', token)
                    },
                });
                // Mark as rendered (widget created successfully)
                this.turnstileRendered = true;
            } catch (e) {
                console.debug('Turnstile render error (ignored):', e)
                this.turnstileRendered = false;
            }
        },
        renderGoogleRecaptcha() {
            try {
                this.widgetId = grecaptcha.render(document.querySelector(`#${this.uniqueId}`), {
                    sitekey: this.siteKey,
                    size: 'invisible',
                    // badge: 'inline',
                    callback: (response) => {
                        console.debug('start recaptcha callback')
                        // reset the recaptcha widget so you can execute it again
                        this.reset()

                        let input = document.createElement('input');
                        input.setAttribute('type', 'hidden');
                        input.setAttribute('name', 'captcha_token');
                        input.setAttribute('value', response);
                        document.querySelector('body').appendChild(input);

                        console.debug('recaptcha response', response, input)

                        this.$emit('verify', response)
                    }
                });

                console.debug('recaptcha widgetId', this.widgetId)
            } catch (e) {
                this.enabled = false;
                if (e.message === 'reCAPTCHA has already been rendered in this element') {
                    console.debug('recaptcha already rendered')
                    this.reset()
                }

                //Essa martelada é devido já ter renderizado um elemento do recaptcha
                //Tem alguma coisa errada que não consigo atribuir o recaptcha no decorrer do formulário
                if (!this.hasError) {
                    this.$nextTick().then(() => {
                        console.debug('recaptcha render again')
                        this.render();
                    });
                    //Incremento essa variável para não entrar em um loop infinito
                    this.hasError = true
                }

                console.debug('recaptcha error', e)
            }
        }
    }
}
</script>

